import { classnames } from '@gatherly/lib';
import { Help as HelpIcon } from '@material-ui/icons';
import { Tooltip } from '../Tooltip';
import classes from './EventLinkList.module.scss';

const HostHelp = (): JSX.Element => {
  return (
    <Tooltip
      className={classnames('small', 'flex justify-center items-center ml_25')}
      content="Hosts can only broadcast to the floor."
    >
      <HelpIcon className={classnames(classes.helpIcon, 'ml_5')} />
    </Tooltip>
  );
};

export default HostHelp;
